import { pick } from 'lodash-es'

export const organizationMembershipToEventTypeMembership = (membership) => (
  {
    type: 'OrganizationMembership',
    organization_membership_id: membership.id,
    owner_availability_rules: membership.availability_rules,
    is_pending: false,
    ...pick(membership, 'user_id', 'name', 'email', 'avatar_url', 'avatar_letter',
      'is_zoom_configured', 'is_gotomeeting_configured', 'is_microsoft_teams_configured',
      'is_webex_configured', 'google_conferencing_configured', 'user_uuid',
      'primary_availability_rule_id')
  }
)

export const invitationToEventTypeMembership = ({ id, email, avatar_letter: avatarLetter, status, uuid }) => ({
  organization_invitation_id: id,
  organization_invitation_uuid: uuid,
  avatar_letter: avatarLetter,
  avatar_url: null,
  email,
  name: email,
  type: 'OrganizationInvitation',
  is_pending: status === 'pending'
})

export const migrationToEventTypeMembership = ({ invitation_id: invitationId,
  invitation_uuid: invitationUUID,
  email,
  avatar_letter: avatarLetter,
  status }) => ({
  organization_invitation_id: invitationId,
  organization_invitation_uuid: invitationUUID,
  avatar_letter: avatarLetter,
  avatar_url: null,
  email,
  name: email,
  type: 'OrganizationInvitation',
  is_pending: status === 'migrating' // They can be treated the same
})
